import React from 'react';
import 'semantic-ui-css/semantic.min.css'
import {Route,Switch, Link} from "react-router-dom";
import routesConfig from './config/routesConfig'
import './App.css';


function App() {

  return (
    <div>

      <Switch>
        {
          routesConfig.map((route, i) => (
            <Route
              exact={route.exact}
              key={route.path}
              path={route.path}
              component={route.component}
            />
          ))
        }{}
      </Switch>

    </div>
  );
}

export default App;
